import { render, staticRenderFns } from "./pickup-apply.vue?vue&type=template&id=7ec84ebc&scoped=true&"
import script from "./pickup-apply.vue?vue&type=script&lang=js&"
export * from "./pickup-apply.vue?vue&type=script&lang=js&"
import style0 from "./pickup-apply.vue?vue&type=style&index=0&id=7ec84ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec84ebc",
  null
  
)

export default component.exports